import { useState, useEffect, useCallback } from 'react';

/**
 * Hook fuer PWA Installation Status und Funktionen
 * Kann von mehreren Komponenten verwendet werden (Login, Banner, etc.)
 */
export function usePWAInstall() {
  const [isIOS, setIsIOS] = useState(false);
  const [isAndroid, setIsAndroid] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);
  const [canInstall, setCanInstall] = useState(false);

  useEffect(() => {
    // Check if already installed (PWA standalone mode)
    const standalone = window.matchMedia('(display-mode: standalone)').matches
      || window.navigator.standalone
      || document.referrer.includes('android-app://');

    setIsStandalone(standalone);

    // Detect mobile device
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const ios = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const android = /android/i.test(userAgent);

    setIsIOS(ios);
    setIsAndroid(android);

    // Check if install prompt is available (Android)
    const checkInstallAvailable = () => {
      setCanInstall(!!window.showPWAInstallPrompt || ios);
    };

    checkInstallAvailable();

    // Listen for install-available event
    const handleInstallAvailable = () => {
      setCanInstall(true);
    };

    const handleInstalled = () => {
      setIsStandalone(true);
      setCanInstall(false);
    };

    window.addEventListener('pwa-install-available', handleInstallAvailable);
    window.addEventListener('pwa-installed', handleInstalled);

    return () => {
      window.removeEventListener('pwa-install-available', handleInstallAvailable);
      window.removeEventListener('pwa-installed', handleInstalled);
    };
  }, []);

  const triggerInstall = useCallback(() => {
    if (isAndroid && window.showPWAInstallPrompt) {
      window.showPWAInstallPrompt();
      return true;
    }
    return false;
  }, [isAndroid]);

  const isMobile = isIOS || isAndroid;
  const showInstallOption = isMobile && !isStandalone;

  return {
    isIOS,
    isAndroid,
    isStandalone,
    isMobile,
    canInstall,
    showInstallOption,
    triggerInstall
  };
}
